import React from 'react';
import styled from 'styled-components';

import { Tooltip } from '@mui/material';
import { FileCopy } from '@mui/icons-material';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import { isMobile } from 'react-device-detect';

import * as theme from '../theme';
import { logUserAction } from '../services/appServices';
import UserActions from '../constants/user-actions';
import { IsEnvDevelpomentOrStaging } from '../utils/enviroment';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        fontSize: isMobile ? theme.typography.pxToRem(14) : theme.typography.pxToRem(16),
        marginTop: '3px',
        backgroundColor: '#fff',
        color: '#3e82b8',
        boxShadow: theme.shadows[1]
    },
    arrow: {
        color: '#fff'
    }
}))(Tooltip);

const TimetableCalendarSubscriptionInstructions = (props) => {
    const { termSchoolId, timetableId, timetableType } = props;

    const generateUrl = () => {
        const baseUrl = IsEnvDevelpomentOrStaging()
            ? 'https://timetablestest.bcit.ca/Calendar/Subscribe'
            : 'https://timetablescalendar.bcit.ca/Calendar/Subscribe';

        if (!timetableType) return 'N/A';

        if (timetableType === 'instructor')
            return baseUrl + `?termSchoolID=${termSchoolId}&instructorID=${timetableId}`;
        if (timetableType === 'set') return baseUrl + `?termSchoolID=${termSchoolId}&setID=${timetableId}`;
    };

    const handleCopyUrl = () => {
        window.navigator.clipboard.writeText(generateUrl());
        logUserAction(UserActions.ICALSUBSCRIPTION, termSchoolId, timetableId, timetableType);
    };

    return (
        <Container {...props}>
            <p>{'Import the following URL in to your calendar'}</p>
            {/*<TimetableBox>*/}
            <SubscriptionUrlContainer>
                <p style={{ fontWeight: 700 }}>{generateUrl()}</p>
                <Tooltip title={'Copy'} placement='top'>
                    <IconButton aria-label='copy' onClick={handleCopyUrl} size="large">
                        <FileCopy fontSize='inherit' />
                    </IconButton>
                </Tooltip>
            </SubscriptionUrlContainer>
            {/*</TimetableBox>*/}
        </Container>
    );
};

const Instructions = (props) => {
    return (
        <Container {...props}>
            <p>{isMobile ? 'Tap on ' : 'Roll-over mouse on '}each item for more information</p>
            <TimetableBox>
                <p style={{ fontWeight: 700 }}>
                    <HtmlTooltip title='Time' arrow enterTouchDelay={10}>
                        <Item children='09:30 - 12:00' />
                    </HtmlTooltip>
                </p>
                <p>
                    <HtmlTooltip title='Course' arrow enterTouchDelay={10}>
                        <Item children='OPMT1130' />
                    </HtmlTooltip>

                    <HtmlTooltip title='Lecture or Lab' arrow enterTouchDelay={10}>
                        <Item children='Lab' />
                    </HtmlTooltip>
                </p>
                <p>
                    <HtmlTooltip title='Building' arrow enterTouchDelay={10}>
                        <Item children='SW1' />
                    </HtmlTooltip>

                    <HtmlTooltip title='Room' arrow enterTouchDelay={10}>
                        <Item children='2016' />
                    </HtmlTooltip>
                </p>
                <p style={{ textDecoration: 'underline', color: '#fff' }}>
                    <HtmlTooltip title='Instructor or Set' arrow enterTouchDelay={10}>
                        <Item children='Marco Reus' />
                    </HtmlTooltip>
                </p>
            </TimetableBox>
        </Container>
    );
};

const Container = styled('div' as any)`
    text-align: center;
    & > :first-child {
        font-size: 13px;
    }
`;

const SubscriptionUrlContainer = styled('div' as any)`
    @media (min-width: 640px) {
        display: flex;
        align-items: flex-start;
    }

    > button {
        margin-top: -10px;
    }
`;

const TimetableBox = styled.div`
    background-color: ${theme.colors.secondary};
    padding: 20px;
`;

const Item = styled.span`
    cursor: pointer;
    padding: 2px 4px;
    color: #fff;
    margin-bottom: 10px;
`;

export { Instructions, TimetableCalendarSubscriptionInstructions };
